module.exports = __webpack_public_path__ + "static/media/main_slider_1.3dcbed92.jpg";